import React from 'react';

export default function Item(props) {
    return (
        <div className="grid grid-cols-12 items-center border-t border-t-cs7 last:border-b last:border-b-cs7">
            <div className="col-start-1 col-end-9 pl-2 flex items-center">
                <span className="font-normal text-sm text-[#000]">{props.desc}</span>
            </div>
            {props.children}
        </div>
    );
}
